export default __webpack_public_path__ + "static/media/filled_locker.a177f537.svg";